import { translateCategory } from 'js/locale/localizationHelper'
import { getEndPoint } from './getEndPoint'

export const getPagesByCategory = ({
  category,
  perPage = 100,
  page = 1,
  subCategory,
}) => {
  const endpoint = `wp/v2/${translateCategory(
    category
  )}?per_page=${perPage}&page=${page}&_embed`

  if (!subCategory) return getEndPoint(endpoint)

  return getEndPoint(
    endpoint +
      `&filter[meta_key]=category&filter[meta_compare]=LIKE&filter[meta_value]=${subCategory}`
  )
}
